import { css } from 'styled-components';
import { StyledButton } from '../../components/Button/Button.styles';
import { StyledLoadingMaskContent } from '../../components/LoadingMaskContent/LoadingMaskContent.styles';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
var fluidCSS = function fluidCSS(mediaProps) {
  return css(["width:", ";"], mediaProps.fluid ? '100%' : 'auto');
};
var disabledCSS = function disabledCSS(_ref) {
  var loading = _ref.loading;
  // Use default disabled styles when not in a loading state
  if (!loading) {
    return '';
  }
  return css(["", ":disabled{transition:none;opacity:1;color:transparent;}"], StyledButton);
};

/** @class LoadingButtonMixin */
/** @method */
export var LoadingButtonMixin = function LoadingButtonMixin(props) {
  return css(["&,", "{", "}", ""], StyledLoadingMaskContent, inlineMediaQueryMixin('fluid', fluidCSS)(props), disabledCSS(props));
};